export default function CTA() {
  return (
    <section className="relative w-full px-4 md:px-6 py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20gradient%20background%20with%20soft%20golden%20and%20coral%20tones%2C%20abstract%20flowing%20light%20ribbons%2C%20clean%20modern%20minimal%20design%2C%20subtle%20particle%20effects%2C%20professional%20atmosphere%2C%20smooth%20texture%2C%20elegant%20composition&width=1600&height=600&seq=cta-bg-2025&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          准备好参与每日竞技了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-xl mx-auto">
          立即访问每日大赛Yandex官网入口，注册账户即可参与每日赛事，赢取丰厚奖励。每天都有新的挑战，每天都有新的机会！
        </p>
        <a
          href="#register"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-rocket-line"></i>
          立即参赛
        </a>
      </div>
    </section>
  );
}